import { render, staticRenderFns } from "./myCoupon.vue?vue&type=template&id=eb31b568&scoped=true&"
import script from "./myCoupon.vue?vue&type=script&lang=js&"
export * from "./myCoupon.vue?vue&type=script&lang=js&"
import style0 from "./myCoupon.vue?vue&type=style&index=0&id=eb31b568&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb31b568",
  null
  
)

export default component.exports